/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./js/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./js/index.js":
/*!*********************!*\
  !*** ./js/index.js ***!
  \*********************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("// eslint-disable-next-line\njQuery(document).ready(function ($) {\n  $(document).foundation(); // Set stupid slider to full width\n  // Trick to compile on server is to run node ./node_modules/gulp/bin/gulp.js\n  // $('#rev_slider_1_1').one('revolution.slide.onloaded', () => {\n  // \tdocument.querySelector('.tp-parallax-wrap').style.removeProperty('left');\n  // \tdocument.querySelector('.tp-caption').style.width = '100vw';\n  // });\n  //  $('[title=\"about\"]').hover(\n  //            function () {\n  //               $(this).css({\"cursor\":\"pointer\"});\n  //               $(\".submenu-container.hide-container.about\").toggle();\n  //            }\n  //  );\n  //\n  //  $('[title=\"impact\"]').hover(\n  //            function () {\n  //               $(this).css({\"cursor\":\"pointer\"});\n  //               $(\".submenu-container.hide-container.impact\").toggle();\n  //            }\n  //  );\n  //\n  // $('[title=\"support\"]').hover(\n  //            function () {\n  //               $(this).css({\"cursor\":\"pointer\"});\n  //               $(\".submenu-container.hide-container.support\").toggle();\n  //            }\n  //  );\n  // append footer content into the mobile menu\n\n  if ($('.fusion-icon.fusion-icon-bars').length > 0) {\n    $('.fusion-icon.fusion-icon-bars').click(function () {\n      if ($(this).attr('aria-expanded') === 'false') {\n        $('html').addClass('overflow-hidden');\n      } else {\n        $('html').removeClass('overflow-hidden');\n      }\n    });\n  }\n\n  jQuery(document).on('open.zf.drilldown', function (e) {\n    if ($('.is-drilldown-submenu-parent a').length > 0) {\n      var submenuHeight = $(e.currentTarget.activeElement).parent().find('.sub-menu').first().height();\n      $(e.currentTarget.activeElement).closest('.is-drilldown').height(submenuHeight + 58);\n    }\n  });\n\n  if ($('.js-drilldown-back a').length > 0) {\n    $('.js-drilldown-back a').click(function (e) {\n      var submenuHeight = $('#responsive-main-menu').height();\n      $(e.target).closest('.is-drilldown').height(submenuHeight + 58);\n    });\n  }\n\n  $(window).resize(function () {\n    if ($('.fusion-icon-bars.hamburger').length > 0 && $('#foundation-mobile-menu').length > 0 && !$('.fusion-icon-bars.hamburger').is(':visible')) {\n      $('#foundation-mobile-menu').css('display', 'none');\n    }\n  });\n});\n\n//# sourceURL=webpack:///./js/index.js?");

/***/ })

/******/ });